<template>
  <div class="doctor-schedule">
    <loading-messages v-if="loading"></loading-messages>
    <template v-else>
      <div class="dates">
        <div class="py-2 px-3 row no-gutters">
          <div class="col-auto first">
            <a class="pointer" @click.prevent="index = 0" v-if="index !== 0">
              <double-arrow-icon></double-arrow-icon>
            </a>
          </div>
          <div class="col-auto prev">
            <a class="pointer" @click.prevent="index--" v-if="index !== 0">
              <angle-icon></angle-icon>
            </a>
          </div>
          <div class="col text-center">
            <template v-if="dates[index]">
              <strong>{{ dates[index] | moment("DD MMMM, dddd") }}</strong>
            </template>
          </div>
          <div class="col-auto next">
            <a
              class="pointer"
              @click.prevent="index++"
              v-if="index !== dates.length - 1"
            >
              <angle-icon></angle-icon>
            </a>
          </div>
        </div>
      </div>
      <div v-if="schedules" class="list-group">
        <div
          v-for="schedule in schedules"
          :key="schedule.id"
          class="list-group-item list-group-item-action"
        >
          <div class="d-flex w-100 justify-content-between align-items-center">
            <h5 class="row align-items-center no-gutters mb-0">
              <div
                :style="{
                  backgroundImage: `url(${staticUrl}${schedule.patient.photo})`
                }"
                class="avatar col-auto mr-2"
                :class="{ online: isOnline(schedule.patient.id) }"
              ></div>
              <div class="col-auto mr-2">
                <div>
                  {{ schedule.patient.firstname[authLocale] }}
                  {{ schedule.patient.lastname[authLocale] }}
                </div>
                <small class="svg">
                  <online-consultation-icon
                    v-if="schedule.clinic_service.type === 'telemedicine'"
                  ></online-consultation-icon>
                  <clinic-icon
                    v-else-if="schedule.clinic_service.type === 'visit'"
                  ></clinic-icon>
                  <ambulance-icon
                    v-else-if="schedule.clinic_service.type === 'house_call'"
                  ></ambulance-icon>
                  <span>
                    {{ $t(schedule.clinic_service.type) }}
                    {{ schedule.clinic_service.name[authLocale] }}
                  </span>
                  <span v-if="!doctorId && schedule.assignee">
                    ({{ schedule.assignee.firstname[authLocale] }}
                    {{ schedule.assignee.lastname[authLocale] }})
                  </span>
                </small>
              </div>
            </h5>
            <div>
              <small class="pr-2" v-if="authType === 'ClinicOperator'">
                {{ Math.round(schedule.price / 100).toFixed(2) }} ₾
                <small
                  href="#"
                  class="badge badge-success svg-sm px-2"
                  @click.prevent
                  v-if="
                    schedule.status === 'pending' ||
                      schedule.status === 'completed'
                  "
                >
                  <check-icon></check-icon> გადახდილია
                </small>
              </small>
              <h4 class="text-right mb-0">
                {{ schedule.start_time | moment("HH:mm") }}
              </h4>
              <div
                v-if="schedule.status === 'pending' && authType === 'Doctor'"
              >
                <a
                  @click.prevent="createCase(schedule.id)"
                  class="btn btn-primary btn-sm svg-sm"
                  href="#"
                >
                  <case-icon></case-icon>
                  <span class="pl-2">{{ $t("createCase") }}</span>
                </a>
                <a
                  v-for="c of ongoingCases"
                  :key="c.id"
                  @click.prevent="attachCase(c)"
                  class="btn btn-primary btn-sm"
                  href="#"
                >
                  <case-icon></case-icon>
                  <span class="pl-2">{{ c.name }}</span>
                  <span class="pl-2">{{ $t("attachCase") }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="editable && patientId && !service && authType === 'Doctor'"
        class="row  my-3"
      >
        <template v-for="s in services">
          <div :key="s.id" class="col" v-if="s.availability[selectedDate]">
            <a
              @click.prevent="chooseService(s)"
              href="#"
              class="btn btn-outline-primary svg-sm "
            >
              <plus-icon></plus-icon>
              განმეორებითი
              {{ $t(s.type) }}
              {{ s.name[authLocale] }}
            </a>
          </div>
        </template>
      </div>
      <div class="m-3" v-if="editable && patientId && !doctorId">
        <hr />
        <h4>ახალი ვიზიტის ჩანიშვნა</h4>
        <div class="form-group" v-if="clinic">
          <label for="label-5">სერვისი</label>
          <multiselect
            v-model="service"
            :options="clinic_services"
            trackBy="id"
            label="name"
          ></multiselect>
        </div>
        <div class="form-check mb-3" v-if="service && service.interview_type">
          <Checkbox :value="interviewType" @change="interviewType != interviewType"></Checkbox>
          <!-- <input
            class="form-check-input"
            id="interview_type"
            type="checkbox"
            v-model="interviewType"
            :value="service.interview_type"
          /> -->
          <label class="form-check-label pointer" for="interview_type" @click="interviewType != interviewType">
            წინასწარი გამოკითხვა
          </label>
        </div>
        <div class="form-group" v-if="doctors && doctors.length > 0">
          <label for="label-5">ექიმი</label>
          <multiselect
            v-model="doctor"
            :options="doctors"
            trackBy="id"
            label="name"
          ></multiselect>
        </div>
      </div>
      <div
        class="times m-3"
        v-if="
          service &&
            editable &&
            (doctorId || doctor) &&
            times &&
            times.length > 0
        "
      >
        <div class="p-3 row no-gutters" v-if="service">
          <div
            class="col-auto text-center border mb-2 mx-2 py-2 rounded"
            style="width: 75px; user-select: none;"
            @click.prevent="time = t"
            v-for="t of times"
            :key="t"
            :class="{
              'bg-primary text-white': time === t,
              'bg-danger': isBooked(t)
            }"
          >
            <small class="py-3 px-2 pointer">{{ t }}</small>
          </div>
        </div>
        <div class="form-group">
          <label for="price">ფასი</label>
          <input
            type="number"
            id="price"
            class="form-control"
            v-model="price"
          />
        </div>
        <div class="form-group">
          <label for="communication_days">კომუნიკაციის დღეების რაოდენობა</label>
          <input
            type="number"
            id="communication_days"
            class="form-control"
            v-model="communication_days"
          />
        </div>

        <button
          class="btn btn-outline-primary btn-block"
          @click.prevent="save"
          :class="{ disabled: !time }"
        >
          დამახსოვრება
        </button>
        <small
          class="my-1 py-2 d-block pointer text-center"
          @click.prevent="(service = null), (time = null)"
          >{{ $t("cancel") }}</small
        >
      </div>
      <div
        v-else-if="service && editable && (doctorId || doctor)"
        class="text-center alert alert-warning"
      >
        {{ selectedDate | moment("DD MMMM") }} - განრიგი არ არის შევსებული
      </div>
    </template>
  </div>
</template>
<script>
import AngleIcon from '@/components/Icons/Angle'
import DoubleArrowIcon from '@/components/Icons/DoubleArrow'
import LoadingMessages from '@/components/Loadings/Message'
import OnlineConsultationIcon from '@/components/Icons/OnlineConsultation'
import ClinicIcon from '@/components/Icons/Clinic'
import AmbulanceIcon from '@/components/Icons/Ambulance'
import Multiselect from 'vue-multiselect'
import CaseIcon from '@/components/Icons/Case'
import CheckIcon from '@/components/Icons/Check'
import PlusIcon from '@/components/Icons/Plus'
import Checkbox from '@/components/Form/Checkbox'
import { mapMutations, mapGetters } from 'vuex'
export default {
  components: {
    AngleIcon,
    DoubleArrowIcon,
    LoadingMessages,
    OnlineConsultationIcon,
    ClinicIcon,
    AmbulanceIcon,
    Multiselect,
    CaseIcon,
    CheckIcon,
    PlusIcon,
    Checkbox
  },
  props: {
    doctorId: {
      type: String,
      default: null
    },
    patientId: {
      type: String,
      default: null
    },
    clinicId: {
      type: String,
      default: null
    },
    onDateChange: {
      type: Function,
      default: () => {}
    },
    editable: {
      type: Boolean,
      default: false
    },
    changeTab: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      loading: false,
      index: 0,
      services: [],
      service: null,
      time: null,
      communication_days: null,
      price: null,
      doctors: [],
      doctor: null,
      dates: [],
      clinic: null,
      interviewType: null
    }
  },
  computed: {
    ...mapGetters({
      staticUrl: 'app/staticUrl',
      authLocale: 'auth/locale',
      authUser: 'auth/user',
      authType: 'auth/type',
      scheduleByDate: 'schedule/byDate',
      scheduleDates: 'schedule/dates',
      isOnline: 'status/isOnline',
      activeCases: 'pcase/active'
    }),
    ongoingCases () {
      const ret = []
      for (const c of this.activeCases) {
        ret.push({
          id: c.id,
          name: this.$moment(c.start_time).format('ddd, DD MMM, h:mm')
        })
      }
      return ret
    },
    selectedDate () {
      return this.dates[this.index]
    },
    schedules () {
      const schedules = this.scheduleByDate(this.dates[this.index])
      if (this.patientId) {
        return schedules.filter(item => {
          return item.patient_id === this.patientId
        })
      }
      return schedules
    },
    times () {
      const ret = []
      let service = null
      if (!this.service.availability) {
        for (const s of this.services) {
          if (s.id === this.service.id) {
            service = s
            break
          }
        }
      } else {
        service = this.service
      }
      if (!service || !service.availability) {
        return ret
      }
      const times = service.availability[this.selectedDate]
      if (!times) {
        return ret
      }
      let found = false
      for (const t of times) {
        const from = this.$moment(t.from).format('HH:mm')
        const to = this.$moment(t.to).format('HH:mm')
        for (let i = 0; i < 1440; i += service.duration) {
          let hour = '' + Math.floor(i / 60)
          let min = '' + (i % 60)
          if (hour.length === 1) {
            hour = '0' + hour
          }
          if (min.length === 1) {
            min = '0' + min
          }
          const time = `${hour}:${min}`
          if (time === from) {
            found = true
          }
          if (time === to) {
            found = false
          }
          if (found) {
            ret.push(time)
          }
        }
      }
      ret.sort((a, b) => {
        if (a > b) {
          return 1
        }
        return -1
      })
      return ret
    },
    clinic_services () {
      const services = []
      if (!this.clinic) {
        return services
      }
      for (const service of this.clinic.services) {
        let name = service.name[this.authLocale]
        if (service.name_addition) {
          name += ` (${service.name_addition[this.authLocale]})`
        }
        services.push({
          id: service.id,
          service_id: service.service_id,
          name: `${this.$t(service.type)} ${name}`,
          price: service.price,
          assignees: service.asignees,
          interview_type: service.interview_type,
          duration: service.duration
        })
      }
      return services
    }
  },
  watch: {
    index (val) {
      this.time = null
      this.onDateChange(this.dates[this.index])
    },
    service (val) {
      this.doctor = null
      if (!val) {
        return
      }
      this.price = (val.price / 100).toFixed(2)
      this.communication_days = 7
      if (val && val.assignees && val.assignees.length > 0) {
        this.fetchDoctor(val.assignees)
      } else {
        this.doctors = []
      }
    },
    doctor (val) {
      if (val) {
        this.fetchAvailability(val.id)
        this.fetchTaken(val.id)
      }
    },
    patientId () {
      this.init()
    },
    doctorId (val) {
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setSchedule: 'schedule/set',
      resetSchedule: 'schedule/reset',
      setAlert: 'alert/setAlert',
      setCase: 'pcase/set'
    }),
    init () {
      for (let i = -14; i < 14; i++) {
        this.dates.push(
          this.$moment()
            .add(i, 'days')
            .format('YYYY-MM-DD')
        )
      }
      this.fetchSchedules()
      this.index = 14
      if (this.editable) {
        if (!this.doctorId) {
          this.fetchClinic(this.clinicId)
        } else {
          this.fetchAvailability(this.doctorId)
          this.fetchTaken(this.doctorId)
        }
      }
    },
    async fetchClinic (id) {
      try {
        const response = await this.axios.get(`/api/clinics/${id}`)
        this.clinic = response.data.data
      } catch (err) {
        this.setError(err)
      }
    },
    isBooked (t) {
      let busy = []
      let found = false
      if (this.doctor.busy && this.doctor.busy[this.dates[this.index]]) {
        busy = this.doctor.busy[this.dates[this.index]]
      }
      for (const b of busy) {
        const from = this.$moment(b.from).format('HH:mm')
        const to = this.$moment(b.to).format('HH:mm')
        for (let i = 0; i < 1440; i += this.service.duration) {
          let hour = '' + Math.floor(i / 60)
          let min = '' + (i % 60)
          if (hour.length === 1) {
            hour = '0' + hour
          }
          if (min.length === 1) {
            min = '0' + min
          }
          const time = `${hour}:${min}`
          if (time === from) {
            found = true
          }
          if (time === to) {
            found = false
          }
          if (found) {
            if (t === time) {
              return true
            }
          }
        }
      }
      return false
    },
    chooseService (service) {
      this.communication_days = 7
      this.price = Math.round(service.price / 100).toFixed(2)
      this.service = service
    },
    async fetchDoctor (ids) {
      this.doctors = []
      try {
        const params = { ids: ids }
        const response = await this.axios.post('/api/users', params)
        const users = response.data.data
        for (const user of users) {
          this.doctors.push({
            id: user.id,
            name: `${user.firstname.ka} ${user.lastname.ka}`,
            avatar: user.photo
          })
        }
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchAvailability (id) {
      try {
        this.loading = true
        const response = await this.axios.get(
          `/api/doctors/${id}/availability`
        )
        this.services = response.data.data
        this.loading = false
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    },
    async fetchTaken (id) {
      try {
        const response = await this.axios.get(
          `/api/doctors/${id}/availability/taken`
        )
        this.doctor.busy = response.data.data
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchSchedules () {
      this.resetSchedule()
      this.loading = true
      const params = {
        offset: 0,
        limit: 20,
        from: this.$moment()
          .subtract(14, 'days')
          .format(),
        to: this.$moment()
          .add(14, 'days')
          .format()
      }
      if (!this.doctorId) {
        params.patient_id = this.patientId
      } else {
        params.assignee_id = this.doctorId
      }
      try {
        const response = await this.axios.get('/api/schedules', {
          params
        })
        const schedules = response.data.data
        let foundIndex = false
        for (const schedule of schedules) {
          this.setSchedule(schedule)
          if (
            !foundIndex &&
            this.$moment(schedule.start_time).diff(this.$moment()) > 0
          ) {
            foundIndex = true
            for (const i in this.dates) {
              if (
                this.dates[i] ===
                this.$moment(schedule.start_time).format('YYYY-MM-DD')
              ) {
                this.index = i
              }
            }
          }
        }
        this.loading = false
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    },
    async save () {
      try {
        this.loading = true
        const params = {
          patient_id: this.patientId,
          clinic_service_id: this.service.id,
          assignee_id: this.doctorId ? this.doctorId : this.doctor.id,
          communication_days: parseInt(this.communication_days),
          start_time: this.$moment(
            `${this.selectedDate} ${this.time}`
          ).format(),
          interview_type: (this.interviewType ? 'SymptomChecker' : null),
          price: this.price * 100
        }
        this.service = null
        this.time = null
        await this.axios.post('/api/schedules', params)
        this.setAlert({
          message: 'განრიგი წარმატებით შეიქმნა',
          type: 'info'
        })
        this.fetchSchedules()
        this.loading = false
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    },
    async attachCase (id) {
      try {
        const params = { patient_case_id: id }
        const response = await this.axios.post(
          `/api/schedules/${this.schedule.id}/bind-patient-case`,
          params
        )
        const c = response.data.data.patient_case
        this.setCase(c)
      } catch (err) {
        this.setError(err)
      }
    },
    async createCase (schedule_id) {
      try {
        const params = { schedule_id: schedule_id }
        const response = await this.axios.post('/api/patient-cases', params)
        const c = response.data.data.patient_case
        this.setCase(c)
        if (this.changeTab) {
          this.changeTab('history')
        }
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<style lang="scss">
.doctor-schedule {
  .service-item {
    svg {
      width: 20px;
      height: 20px;
    }
  }
  .dates {
    font-size: 0.75em;
    background: #3c88ff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    // position: sticky;
    // top: 0;
    // z-index: 200;
    color: #fff;
    .first {
      transform: rotate(180deg);
      svg {
        width: 20px;
        height: 20px;
      }
    }
    .prev {
      transform: rotate(90deg);
      svg {
        width: 20px;
        height: 20px;
      }
    }
    .next {
      transform: rotate(-90deg);
      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "createSchedule": "ჩანიშვნა",
      "cancel": "გაუქმება",
      "createCase": "ქეისის შექმნა",
      "telemedicine": "ონლაინ",
      "visit": "კლინიკაში",
      "house_call": "გამოძახება",
      "attachCase": "ქეისზე მიმაგრება"
  }
}
</i18n>
